import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Fab from '@mui/material/Fab';
import Divider from '@mui/material/Divider';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';

import { LocalizationContext, SocketContext } from '../../../../../AppContext';
import Confirm from '../../../../../components/Confirm';
import Snackbar from '../../../../../components/Snackbar';
import localization from './ReportstatusesPatch.local';

export default function ReportstatusesPatch({
  reportstatuses,
  onBack,
  onSetReportstatuses,
}) {
  const local = localization[useContext(LocalizationContext)];
  const socket = useContext(SocketContext);
  const { reportstatusid } = useParams();
  const [reportstatus, setReportstatus] = useState();
  const [name, setName] = useState('');
  const [typingTimeout, setTypingTimeout] = useState();
  const [alert, setAlert] = useState();
  const [openConfirm, setOpenConfirm] = useState();

  useEffect(() => {
    if (reportstatuses && reportstatusid) {
      const foundUser = reportstatuses.find((item) => item.id === parseInt(reportstatusid, 10));
      if (foundUser) {
        setReportstatus(foundUser);
      } else {
        onBack();
      }
    }
  }, [reportstatuses, reportstatusid]);

  useEffect(() => {
    if (reportstatus) {
      setName(reportstatus.name);
    }
  }, [reportstatus]);

  const acknowledgeChange = ({ error, payload }) => {
    setAlert(error || 200);
    if (!error) {
      onSetReportstatuses(reportstatuses ? reportstatuses.map((item) => (item.id === payload.id ? payload : item)) : [payload]);
    }
  };

  const onChange = (field, value) => {
    const params = {
      id: reportstatuses.id,
      field,
      value,
    };
    socket.emit('reportstatuses.patch', params, acknowledgeChange);
  };

  const onTextChange = (setter, field, value) => {
    setter(value);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTypingTimeout(setTimeout(() => onChange(field, value), 1000));
  };

  const acknowledgeDestroy = ({ error, payload }) => {
    if (error) {
      setAlert(error);
    } else {
      onSetReportstatuses(reportstatuses ? reportstatuses.filter((item) => (item.id !== payload.id)) : []);
      onBack();
    }
  };

  const onDestroy = () => {
    const params = { id: reportstatus.id };
    socket.emit('reportstatuses.destroy', params, acknowledgeDestroy);
  };

  return (
    <Paper sx={{ height: '100%', p: 5 }}>
      <Confirm
        title={local.destroyTitle}
        description={local.destroyDescription}
        agree={local.agree}
        disagree={local.disagree}
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        onConfirm={onDestroy}
      />
      <Snackbar alert={alert} local={local.alerts} onClose={() => setAlert()} />
      <Typography variant="h4">{local.title}</Typography>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Grid container spacing={2}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={5}>
            {local.firstname}
          </Grid>
          <Grid item xs={5}>
            <TextField
              fullWidth
              variant="outlined"
              color="secondary"
              margin="dense"
              label={local.name}
              value={name}
              onChange={(e) => onTextChange(setName, 'name', e.target.value)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Stack spacing={1} sx={{ position: 'fixed', right: 30, bottom: 40 }}>
        { reportstatus && (
          <Fab
            variant="extended"
            color="primary"
            size="small"
            onClick={() => setOpenConfirm(true)}
            sx={{ justifyContent: 'flex-start' }}
          >
            <DeleteIcon sx={{ mr: 1 }} />
            <Typography>{local.destroy}</Typography>
          </Fab>
        )}
        <Fab
          variant="extended"
          color="secondary"
          size="small"
          onClick={onBack}
          sx={{ justifyContent: 'flex-start' }}
        >
          <CancelIcon sx={{ mr: 1 }} />
          <Typography>{local.back}</Typography>
        </Fab>
      </Stack>
    </Paper>
  );
}

ReportstatusesPatch.propTypes = {
  reportstatuses: PropTypes.arrayOf(PropTypes.shape({})),
  onBack: PropTypes.func.isRequired,
  onSetReportstatuses: PropTypes.func.isRequired,
};

ReportstatusesPatch.defaultProps = {
  reportstatuses: undefined,
};
